import { __decorate, __metadata } from "tslib";
import { CacheActivePromise } from '@1inch-community/core/decorators';
import { lazyAppContext } from '@1inch-community/core/lazy';
export class PrivateProxyClient {
    constructor() {
        this.token = null;
        this.expirationTime = null;
        this.context = lazyAppContext('PrivateProxyClient');
    }
    get isAuth() {
        return !!this.expirationTime && this.expirationTime > Date.now();
    }
    get host() {
        return this.context.value.environment.get('oneInchDevPortalHost');
    }
    async init(context) {
        this.context.set(context);
        this.expirationTime =
            this.context.value.storage.get('private-proxy-client-expiration-time', Number) ?? null;
        this.token = this.context.value.storage.get('private-proxy-client-token', String) ?? null;
    }
    async get(url) {
        await this.auth();
        const response = await fetch(this.getRequestUrl(url), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.token}`,
            },
        });
        return await response.json();
    }
    async post(url, body) {
        await this.auth();
        const response = await fetch(this.getRequestUrl(url), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.token}`,
            },
            body: JSON.stringify(body),
        });
        return await response.json();
    }
    async auth() {
        if (this.isAuth)
            return;
        const turnstileToken = await this.context.value.turnstile.getToken();
        const response = await fetch(this.getRequestUrl('/auth'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                token: turnstileToken,
            }),
        });
        const { token, expiration_time } = (await response.json());
        this.token = token;
        this.expirationTime = expiration_time * 1000 - 2000;
        this.context.value.storage.set('private-proxy-client-token', this.token);
        this.context.value.storage.set('private-proxy-client-expiration-time', this.expirationTime);
        console.warn('auth complete');
    }
    getRequestUrl(urlPath) {
        const url = new URL(urlPath, this.host);
        url.pathname = url.pathname.replace(/\/+/g, '/');
        return url;
    }
}
__decorate([
    CacheActivePromise(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], PrivateProxyClient.prototype, "auth", null);
//# sourceMappingURL=private-proxy-client.js.map